export default "__VITE_ASSET__C7mEm02b__"